
// function logEvent(id, event) {
//   const events = document.getElementById('events');
//   const li = document.createElement('li');
//   const time = parseInt(event.timeStamp);

//   // html-webpack-plugin does not work with ES6 template strings =/
//   li.appendChild(document.createTextNode(id + ': ' + time + ' - ' + event.type));
//   events.appendChild(li);
// }

// document.addEventListener('DOMContentLoaded', function() {
//   const menuLeftElem = document.getElementById('left-menu');

//   const allEvents = [
//     'sm.back',
//     'sm.back-after',
//     'sm.close',
//     'sm.close-after',
//     'sm.forward',
//     'sm.forward-after',
//     'sm.navigate',
//     'sm.navigate-after',
//     'sm.open',
//     'sm.open-after',
//   ];


//   const menuLeft = new SlideMenu(menuLeftElem, {
//     position: 'left',
//     keyClose: 'Escape',
//     submenuLinkAfter: '<span style="margin-left: 1em; font-size: 85%;">↠</span>',
//     backLinkBefore: '<span style="margin-right: 1em; font-size: 85%;">↞</span>',
//   });

//   if (window.innerWidth > 767) {
//     menuLeft.open(false);
//   }
// });   


(function() {
  var iconUrl = window.CC && window.CC.sizeChartIconUrl;
  if (!iconUrl) return;

  function replaceKiwiIcon() {
    document.querySelectorAll('img.kiwi-svg:not([data-cc-replaced])').forEach(function(img) {
      img.src = iconUrl;
      img.dataset.ccReplaced = 'true';
    });
  }

  replaceKiwiIcon();

  new MutationObserver(replaceKiwiIcon).observe(document.body, {
    childList: true,
    subtree: true
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  // Kiwi Sizing's "Size Guide" trigger (.ks-chart-container) and Wair's
  // "What's my size?" CTA (.predict-placement.wair-css) each land wherever
  // their own third-party script happens to inject them, and neither is
  // reliably first - Kiwi is sometimes still loading when Wair's already
  // ready (confirmed via devtools). Pull each into the shared row
  // independently, as soon as it individually becomes available, instead
  // of requiring both to exist before moving either - the previous version
  // moved neither if Kiwi hadn't appeared yet, even when Wair was already
  // sitting there ready to go. See .cc-size-helpers in
  // custom-styles.css.liquid for the layout.
  function getSizeHelpersRow() {
    var wrapper = document.querySelector('.cc-size-helpers');
    if (wrapper) return wrapper;

    var selectorWrappers = document.querySelectorAll('.selector-wrapper');
    var lastSelector = selectorWrappers[selectorWrappers.length - 1];
    if (!lastSelector) return null;

    wrapper = document.createElement('div');
    wrapper.className = 'cc-size-helpers';
    lastSelector.after(wrapper);
    return wrapper;
  }

  function moveSizeHelpers() {
    var sizeChart = document.querySelector('.ks-chart-container');
    var predictPlacement = document.querySelector('.predict-placement.wair-css');
    if (!sizeChart && !predictPlacement) return false;

    var wrapper = getSizeHelpersRow();
    if (!wrapper) return false;

    // Only move an element that isn't already in place - appendChild on an
    // element that's already wrapper's child still fires a childList
    // mutation (it's a remove + insert), which the observer below watches
    // on document.body/subtree. Appending unconditionally on every call
    // meant that whenever only one widget ever showed up, each observer
    // callback generated a fresh mutation that retriggered itself forever,
    // freezing the page (see #58).
    if (sizeChart && sizeChart.parentNode !== wrapper) wrapper.appendChild(sizeChart);
    if (predictPlacement && predictPlacement.parentNode !== wrapper) wrapper.appendChild(predictPlacement);

    return !!(sizeChart && predictPlacement);
  }

  if (!moveSizeHelpers()) {
    // Keep watching briefly for whichever widget hasn't shown up yet, so
    // it still joins the row instead of being left behind. Also watch
    // class changes, not just new elements - Wair marks itself ready by
    // adding the wair-css class to a div that may already be on the page,
    // which a childList-only observer would miss entirely. Give up after
    // 8s in case a product genuinely has no Wair CTA configured, leaving
    // whichever widget did load in place on its own.
    //
    // The give-up check has to run on its own timer, not just inside the
    // mutation callback (see #58) - checking elapsed time only when *some*
    // mutation happens to fire meant an unrelated mutation landing right
    // after the 8s mark, but before Wair's own "ready" mutation, would
    // disconnect the observer moments too early and permanently miss it.
    var observer = new MutationObserver(function () {
      if (moveSizeHelpers()) {
        clearTimeout(giveUpTimer);
        observer.disconnect();
      }
    });
    var giveUpTimer = setTimeout(function () {
      observer.disconnect();
    }, 8000);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }
});

(function () {
  function slideSize(track) {
    var slide = track.querySelector('[data-cc-image-carousel-slide]');
    if (!slide) return track.clientWidth;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  function updateNav(track, prev, next) {
    if (!prev || !next) return;
    var maxScroll = track.scrollWidth - track.clientWidth - 1;
    prev.disabled = track.scrollLeft <= 0;
    next.disabled = track.scrollLeft >= maxScroll;
  }

  function initCarousel(carousel) {
    if (!carousel || carousel.dataset.ccCarouselReady === 'true') return;

    var track = carousel.querySelector('[data-cc-image-carousel-track]');
    if (!track) return;

    var prev = carousel.querySelector('[data-cc-image-carousel-prev]');
    var next = carousel.querySelector('[data-cc-image-carousel-next]');

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -slideSize(track), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: slideSize(track), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', function () {
      updateNav(track, prev, next);
    }, { passive: true });

    window.addEventListener('resize', function () {
      updateNav(track, prev, next);
    });

    updateNav(track, prev, next);
    carousel.dataset.ccCarouselReady = 'true';
  }

  function initCarousels(root) {
    var scope = root || document;
    var carousels = scope.querySelectorAll('[data-cc-image-carousel]');
    for (var i = 0; i < carousels.length; i++) {
      initCarousel(carousels[i]);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCarousels(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initCarousels(event.target);
  });
})();

(function () {
  // Whether a product has reviews only exists inside Yotpo, client-side -
  // Yotpo doesn't sync review counts into a Shopify metafield on this store
  // (see #53). Both the Yotpo widget and the "Be the first to review" link
  // are rendered hidden in snippets/cc_product__icons.liquid; this watches
  // each Yotpo widget instance and reveals whichever is actually correct
  // once Yotpo reports real data.
  //
  // Originally keyed off a `yotpo-sr-bottom-line-new-review` class, which
  // turned out to belong to Yotpo's separate full "Bottom Line" widget, not
  // this compact "Star Ratings" widget instance (data-yotpo-instance-id
  // 1120844) - it never appears here at all, confirmed via devtools, so
  // hasNoReviews was always false and the empty stars stayed visible
  // instead of collapsing in favour of the "Be the first to review" link.
  //
  // Yotpo's own .yotpo-sr-bottom-line-button spells the review count out in
  // plain text via its aria-label (e.g. "0 out of 5 stars rating in total
  // 0 reviews. Jump to reviews.") - reading that is a reliable signal for
  // this widget instance, rather than guessing at an internal class name.
  function initReviewToggle(widget) {
    if (!widget || widget.dataset.ccReviewToggleReady === 'true') return;

    var emptyLink = widget.parentElement && widget.parentElement.querySelector('[data-cc-review-empty-link]');
    if (!emptyLink) return;

    function toggle() {
      var bottomLineButton = widget.querySelector('.yotpo-sr-bottom-line-button');
      if (!bottomLineButton) return;

      var reviewCountMatch = (bottomLineButton.getAttribute('aria-label') || '').match(/in total (\d+) review/i);
      var hasNoReviews = !!reviewCountMatch && reviewCountMatch[1] === '0';

      widget.classList.toggle('is-hidden', hasNoReviews);
      emptyLink.classList.toggle('is-hidden', !hasNoReviews);
    }

    var observer = new MutationObserver(toggle);
    observer.observe(widget, { childList: true, subtree: true });
    toggle();
    widget.dataset.ccReviewToggleReady = 'true';
  }

  function initReviewToggles(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-cc-review-widget]').forEach(initReviewToggle);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReviewToggles(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initReviewToggles(event.target);
  });
})();

  function textOpenClose(input) {
    
              
              var moreText = document.getElementById("more"+input);
              var btnReadMore = document.getElementById("myBtnReadMore"+input);
              var btnClose = document.getElementById("myBtnClose"+input);
              var focusLocation = document.getElementById("shopify-section-"+input);
              
              if (btnReadMore.style.display === "none") {
                
                btnReadMore.style.display = "inline"; 
                moreText.style.display = "none";
                focusLocation.scrollIntoView();

              } else {
               
                btnReadMore.style.display = "none";
                btnClose.style.display = "block";
                moreText.style.display = "block";
              }
            }
   